import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/**
 * Container component for the E-Visit page.
 */
class Video extends React.Component {
    constructor(props) {
        super(props);
        const data = typeof window !== 'undefined' ? window.serverData.data : null;
    }
    render() {
        const { inPerson } = this.props;
        return (
            <div id="video-visit-landing" className="container-fluid body-content video-visits-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">Video Visits</h1>

                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <span>Video visits are currently only available in the MyBSWHealth app.
                                    Take advantage of this feature by downloading the app or logging in today!
                                    </span>
                                <div className="ratings">
                                    <h3>4.7 Rating</h3>
                                    <img alt="stars-my-care-tasks" src="images/stars-my-care-tasks.png" />
                                    <span>With 17k+ reviews & 300k+ users</span>
                                </div>
                                <div className="app-icons">
                                    <a href="https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8" target="_blank">
                                        <img alt="app-store" src="images/app-store.png" />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en" target="_blank">
                                        <img alt="google-store" src="images/google-store.png" />
                                    </a>
                                </div>
                                <div className="video-visits__details">
                                <h5>WHAT CAN BE TREATED?</h5>
                                    <ul>
                                        <li>Cold, Flu, Allergies: Sinus, sore throat</li>
                                        <li>Women's Health: UTI, yeast infection</li>
                                        <li>Minor Eye Conditions: Pinkeye</li>
                                        <li>Skin Conditions: Acne, cold sore</li>
                                        <li>Stomach/Digestive Issues: Constipation, diarrhea</li>
                                        <li>Sprains and Strains</li>
                                    </ul>
                                    <span>Video visits can be booked between</span> <span className="day-time">8am - 5pm (M-F)</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 phone-img">
                                <img alt="my-care-task" src="images/my-care-task.png" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Video);